import React from 'react'
import { Switch } from 'react-router-dom'

import { PermissionRoute } from '../../common/components/routes'
import { APP_ROUTES, PERMISSIONS } from '../../common/constants'

import { LocationTypeDetailsPage, LocationTypesPage } from './pages'

const LocationTypesRouter = () => (
  <Switch>
    <PermissionRoute
      exact
      path={APP_ROUTES.LOCATION_TYPES.link}
      permissions={[PERMISSIONS.METADATA_TREE.LIST]}
      component={LocationTypesPage}
    />
    <PermissionRoute
      exact
      path={APP_ROUTES.LOCATION_TYPE_DETAILS.link}
      permissions={[PERMISSIONS.METADATA_TREE.GET]}
      component={LocationTypeDetailsPage}
    />
  </Switch>
)

export default LocationTypesRouter
